<template>
  <div class="home-container">
    <HomepageHeader class="header"></HomepageHeader>

    <div class="body">
      <div class="container-fluid" v-if="APP_GAR == 'true'">
        <div class="notice">
          <div class="col-md-8 notice-content">
            <h4 class="section-subtitle">
              {{ $t(`home.gar_notice`) }}
            </h4>
          </div>
        </div>
      </div>

      <div class="origin" :style="{ backgroundImage: originBackground }">
        <div class="column left">
          <div class="title">{{ $t(`home.origin_iizenglish.title`) }}</div>
          <div class="content">
            <p>
              {{ $t(`home.origin_iizenglish.firstLine`) }}
            </p>
            <ul>
              <li class="origin-first-pill">
                {{ $t(`home.origin_iizenglish.liOne`) }}
              </li>
              <li>{{ $t(`home.origin_iizenglish.liTwo`) }}</li>
            </ul>
            <p>
              {{ $t(`home.origin_iizenglish.paragraphOne`) }}
            </p>
            <p>
              {{ $t(`home.origin_iizenglish.paragraphTwo`) }}
            </p>
          </div>
          <div class="more-info">
            <router-link :to="{ name: 'AboutIizenglish' }">
              {{ $t(`home.moreInfo`) }}
            </router-link>
          </div>
        </div>
        <div class="column right">
          <img class="image" :src="originImage" />
        </div>
      </div>

      <div class="offer" :style="{ backgroundImage: offerBackground }">
        <div class="title">{{ $t(`home.offer.title`) }}</div>
        <div class="cards">
          <div class="card left">
            <div class="icon"><img :src="studentIcon" /></div>
            <div class="arrow-text-alt">
              {{ $t(`home.offer.teacherTitle`) }}
            </div>
            <div class="arrow-container left-arrow-container">
              <div class="text">{{ $t(`home.offer.teacherTitle`) }}</div>
              <div class="arrow"><img :src="leftArrow" /></div>
            </div>
            <div class="body">
              <ul>
                <li>
                  {{ $t(`home.offer.forTeacherAdvantages[0]`) }}
                </li>
                <li>
                  {{ $t(`home.offer.forTeacherAdvantages[1]`) }}
                </li>
                <li>
                  {{ $t(`home.offer.forTeacherAdvantages[2]`) }}
                </li>
                <li>
                  {{ $t(`home.offer.forTeacherAdvantages[3]`) }}
                </li>
              </ul>
            </div>
          </div>

          <div class="card right">
            <div class="icon"><img :src="teacherIcon" /></div>
            <div class="arrow-text-alt">
              {{ $t(`home.offer.studentTitle`) }}
            </div>
            <div class="arrow-container right-arrow-container">
              <div class="text">{{ $t(`home.offer.studentTitle`) }}</div>
              <div class="arrow"><img :src="rightArrow" /></div>
            </div>
            <div class="body">
              <ul>
                <li>
                  {{ $t(`home.offer.forStudentsAdvantages[0]`) }}
                </li>
                <li>
                  {{ $t(`home.offer.forStudentsAdvantages[1]`) }}
                </li>
                <li>
                  {{ $t(`home.offer.forStudentsAdvantages[2]`) }}
                </li>
                <li>
                  {{ $t(`home.offer.forStudentsAdvantages[3]`) }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="plan" :style="{ backgroundImage: planBackground }">
        <div class="all-device-container">
          <div class="column left">
            <img class="all-device-image" :src="allDeviceImage" />
          </div>

          <div class="column right">
            <img class="planet-pen-image" :src="planImage" />
            <div class="text">{{ $t(`home.plan.allDevice`) }}</div>
            <img class="ligne-image" :src="planLigne" />
            <img class="planet-image" :src="planPlanet" />
          </div>
        </div>

        <div class="plan-container">
          <div class="title">{{ $t(`home.plan.howItWorks`) }}</div>
          <div class="cards">
            <div class="card" v-for="key in [...Array(3).keys()]" :key="key">
              {{
                $t(`home.plan.plans[${key}]`, {
                  price: price,
                })
              }}
            </div>
          </div>
          <div class="more-info">
            <router-link :to="{ name: 'AboutIizenglish' }">
              {{ $t(`home.moreInfo`) }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import FormePlaneteIizenglishRose from "@/assets/homepage/forme-planete-iizenglish-rose.webp";
import PhotoGraduationDay from "@/assets/homepage/photo-graduation-day-768x512.webp";
import PatternIizenglishHomeAvantages from "@/assets/homepage/pattern-iizenglish-home-avantages.webp";
import Eleve from "@/assets/homepage/eleve.webp";
import Prof from "@/assets/homepage/prof.webp";
import LeftArrow from "@/assets/homepage/left-arrow.webp";
import RightArrow from "@/assets/homepage/right-arrow.webp";
import PatternIizenglishHomeMultisupport from "@/assets/homepage/pattern-iizenglish-home-multisupport.webp";
import MockupsIizenglish from "@/assets/homepage/mockups-iizenglish-768x673.webp";
import SubTitle4 from "@/assets/homepage/sub-title-4.webp";
import FormeLigneIizenglishJaune1 from "@/assets/homepage/forme-ligne-iizenglish-jaune-1-1024x21.webp";
import FormePlaneteIizenglishBleu from "@/assets/homepage/forme-planete-iizenglish-bleu.webp";
import HomepageHeader from "@/components/homepage/HomepageHeader";

export default {
  name: "HomePage",
  components: {
    HomepageHeader,
  },
  data() {
    return {
      APP_GAR: import.meta.env.VITE_GAR,
      originBackground: `url(${FormePlaneteIizenglishRose})`,
      originImage: PhotoGraduationDay,
      offerBackground: `url(${PatternIizenglishHomeAvantages})`,
      studentIcon: Eleve,
      teacherIcon: Prof,
      leftArrow: LeftArrow,
      rightArrow: RightArrow,
      planBackground: `url(${PatternIizenglishHomeMultisupport})`,
      allDeviceImage: MockupsIizenglish,
      planImage: SubTitle4,
      planLigne: FormeLigneIizenglishJaune1,
      planPlanet: FormePlaneteIizenglishBleu,
    };
  },
  computed: {
    price() {
      let subscriptionPrice =
        this.$store.getters["users/getCountry"].subscription_price;
      const currency = this.$store.getters["users/getCountry"].currency;
      if (subscriptionPrice != null) {
        subscriptionPrice = subscriptionPrice.toLocaleString(
          this.$i18n.locale,
          { minimumFractionDigits: 2 },
        );
      }
      // TODO: Fix => this.$n doesn't work for numberFormats !
      const displayPrice =
        this.$i18n.locale === "en"
          ? `${currency}${subscriptionPrice}`
          : `${subscriptionPrice}${currency}`;
      return displayPrice;
    },
  },
  mounted() {
    this.$store.dispatch("users/getLocalization");
  },
};
</script>

<style scoped lang="scss">
.home-container {
  text-align: center;

  .body {
    .notice {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0em 1em 0em 1em;

      .notice-content {
        background-color: $primaryColor;
        border-radius: 3em 3em 3em 3em;
        padding: 1em 1em 1em 1em;
        margin: 2em auto 1em auto;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        .section-subtitle {
          font-family: "Averia Sans Libre", sans-serif;
          font-size: 1.8em;
          color: $whiteColor;
        }
      }
    }

    .origin {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 50px 0px 50px 0px;
      background-position: center left;
      background-repeat: no-repeat;
      background-size: 39% auto;
      background-color: $whiteColor;
      box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, 0.8);

      .column {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 570px;
      }

      .left {
        padding: 0px 50px 0px 50px;

        .title {
          font-family: "Averia Sans Libre", sans-serif;
          font-size: 2em;
          color: $primaryColor;
          margin-bottom: 20px;
        }

        .content {
          text-align: justify;
        }

        .origin-first-pill {
          margin-bottom: 0.5rem;
        }

        .more-info {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 200px;
          border: 3px solid $secondaryColor;
          color: $secondaryColor;
          height: 40px;
          border-radius: 20px;
          margin-top: 30px;

          a {
            text-decoration: none;
            color: inherit;
          }

          &:hover {
            cursor: pointer;
            color: $whiteColor;
            background-color: $secondaryColor;
          }
        }
      }

      .right {
        .image {
          width: 456px;
          border-radius: 18%;
        }
      }

      @media screen and (max-width: 992px) {
        .right {
          display: none;
        }
      }
    }
  }

  .offer {
    background-color: $primaryColorLight;
    box-shadow: inset 0 0 0 1000px rgba(185, 206, 234, 0.8);
    background-position: bottom left;
    background-size: cover;
    padding: 50px 0px 50px 0px;

    .title {
      font-family: "Averia Sans Libre", sans-serif;
      font-size: 2em;
      color: $primaryColor;
      margin-bottom: 60px;
    }

    .cards {
      display: flex;
      justify-content: center;

      .card {
        position: relative;
        display: flex;
        justify-content: center;
        max-width: 424px;
        padding: 20px;
        border-radius: 50px;
        background-color: $whiteColor;
        margin: 20px 30px 0px 30px;

        .icon {
          margin-bottom: 20px;
        }

        .arrow-text-alt {
          color: $secondaryColor;
        }

        .arrow-container {
          position: absolute;
          top: -120px;
          width: 150px;

          .text {
            color: $secondaryColor;
            position: relative;
            width: 120px;
          }

          .arrow {
            height: 161px;
          }
        }

        @media screen and (max-width: 992px) {
          .arrow-container {
            display: none;
          }
        }

        @media screen and (min-width: 993px) {
          .arrow-text-alt {
            display: none;
          }
        }

        .left-arrow-container {
          left: 20px;

          .text {
            left: -50px;
          }
        }

        .right-arrow-container {
          right: 20px;

          .text {
            left: 50px;
          }
        }

        .body {
          text-align: left;

          ul {
            li {
              margin: 10px 0px 10px 0px;
            }
          }
        }
      }
    }

    @media screen and (max-width: 768px) {
      .cards {
        flex-direction: column;
        align-items: center;

        .card {
          margin: 20px 10px 0px 10px;
        }
      }
    }
  }

  .plan {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, 0.8);
    background-position: center center;
    background-size: cover;
    padding-top: 50px;

    .all-device-container {
      display: flex;
      justify-content: center;
      margin: 0px 0px 50px 0px;

      .column {
        max-width: 540px;
        margin: 0px 20px 0px 20px;
      }

      .left {
        .all-device-image {
          width: 100%;
        }
      }

      .right {
        .planet-pen-image {
          width: 100%;
        }

        .text {
          font-family: "Averia Sans Libre", sans-serif;
          margin: 20px 0px 20px 0px;
          font-size: 1.75em;
        }

        .ligne-image {
          width: 100%;
        }

        .planet-image {
          margin-top: 20px;
          width: 80%;
        }
      }
    }

    @media screen and (max-width: 992px) {
      .all-device-container {
        flex-direction: column;
      }

      .column {
        width: 300px;
      }

      .planet-image {
        min-width: 50%;
        max-width: 50%;
      }
    }

    .plan-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 15% 15% 0% 0%;
      background-color: $primaryColorLight;
      margin: 0px 20px 0px 20px;
      padding: 50px;
      text-transform: uppercase;

      .title {
        font-family: "Averia Sans Libre", sans-serif;
        font-size: 2em;
        color: $primaryColor;
        margin-bottom: 30px;
      }

      .cards {
        display: flex;
        justify-content: space-between;

        .card {
          background-color: $whiteColor;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 3px solid $tertiaryColor;
          border-radius: 20px;
          padding: 20px 50px 20px 50px;
          max-width: 250px;
          margin: 20px 20px 20px 20px;
          font-weight: bold;
        }
      }

      .more-info {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        border: 3px solid $secondaryColor;
        background-color: $secondaryColor;
        color: $whiteColor;
        height: 40px;
        border-radius: 20px;
        margin-top: 30px;

        a {
          text-decoration: none;
          color: inherit;
        }

        &:hover {
          cursor: pointer;
          color: $secondaryColor;
          background-color: $whiteColor;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .plan-container {
        padding: 25px 20px;
        border-radius: 30px 30px 0% 0%;
      }

      .cards {
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
</style>
